// import port1 from "../../assets/google.jpg";
// import port2 from "../../assets/google2.jpg";
// import port3 from "../../assets/google3.jpg";
// import port4 from "../../assets/growcify.jpg";
// import port5 from "../../assets/vtu.jpg";
// import port6 from "../../assets/free.jpg";
// import port7 from "../../assets/tute.jpg";
// import port8 from "../../assets/zeta.jpg";
// import port9 from "../../assets/buildProto.jpg"

export const data = [
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/g1.jpg?updatedAt=1719466858057',
        url: 'https://www.coursera.org/account/accomplishments/verify/JMKLLFE8NVA3?utm_source%3Dandroid%26utm_medium%3Dcertificate%26utm_content%3Dcert_image%26utm_campaign%3Dsharing_cta%26utm_product%3Dcourse',
        heading : 'Foundation of UX design'
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/g2.jpg?updatedAt=1719466857815',
        url: 'https://coursera.org/share/09d80cc31c61dc9a12621cf996303aee',
        heading : 'Empathize, Define & Ideate'
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/g3.jpg?updatedAt=1719466857985',
        url: 'https://www.coursera.org/account/accomplishments/verify/34FVF9CCUN8K?utm_source%3Dandroid%26utm_medium%3Dcertificate%26utm_content%3Dcert_image%26utm_campaign%3Dsharing_cta%26utm_product%3Dcourse',
        heading : 'Conduct UX Research'
    },
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/growcify%20(1).jpg?updatedAt=1719466858873' ,
        url: 'https://drive.google.com/file/d/108WHLBnkz9G5CwZqLXWdavfGkkjv0_oM/view?usp=drivesdk',
        heading : 'Growcify Internship letter'
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/vtu.jpg?updatedAt=1719466855963',
        url: 'https://drive.google.com/file/d/1XvmT5SFMZzdCl81u68-_M6wUhLnA9wc-/view?usp=drivesdk',
        heading : 'VTU Honour letter'
    },
    {
        img: 'https://ik.imagekit.io/35sznjvlf/assets/f1.jpg?updatedAt=1719466858398',
        url: 'https://freecodecamp.org/certification/fcc57b44fb5-c98b-4387-933b-35fcbf2c2013/responsive-web-design',
        heading : 'Responsive Webdesign freecodecamp'
    },
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/tute%20(1).jpg?updatedAt=1719466856189' ,
        url: 'https://drive.google.com/file/d/1_G5D0fCWdl_m8kIM2xBkpwy7U9vSSii8/view?usp=drivesdk',
        heading : 'UI/UX Designing Tutedude'
    },
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/zeta.jpg?updatedAt=1719466856028' ,
        url: 'https://drive.google.com/file/d/1u5Pkh-6RAhkNt3s0cVyWlNzAqtq8-4vb/view?usp=drivesdk',
        heading : 'Inventory Management-Django'
    },
    {
        img:'https://ik.imagekit.io/35sznjvlf/assets/bwImg.jpg?updatedAt=1719466858134' ,
        url: 'https://www.coursera.org/account/accomplishments/verify/DR25NKFQALLA?utm_source%3Dandroid%26utm_medium%3Dcertificate%26utm_content%3Dcert_image%26utm_campaign%3Dsharing_cta%26utm_product%3Dcourse',
        heading : 'Build Wireframes & Low-Fi Prototypes'
    },
]